import { State, process } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import { useCallback, useMemo, useState } from 'react';
import poVarianceColumns from 'src/assets/static/variance_details/poVarianceColumns';
import GridWrapper from 'src/components/GridWrapper';
import Accordion from 'src/components/design-system/Accordion';
import useVarianceDetails from 'src/hooks/useVarianceDetails';
import usePoDocuments from 'src/services/usePoDocumentsApi';
import VarianceDetailsToolBar from './VarianceDetailsToolBar';

const DATA_ITEM_KEY: string = 'rowId';
const initialDataState: State = {
  skip: 0,
  take: 20,
  sort: [],
};
const gridPagerSettings: GridPagerSettings = {
  buttonCount: 5,
  pageSizes: [10, 20, 50, 100],
};
const defaultProps = {
  tableTextId: 'Documents',
  DataItemKey: DATA_ITEM_KEY,
  sortable: true,
  resizable: true,
  showColumnMenu: true,
  pageable: gridPagerSettings,
} as const;

const PoVarianceDocument = () => {
  const { poNumber, poId } = useVarianceDetails();
  const { isLoading, poDocuments } = usePoDocuments(poId);
  const [variantDataState, setVariantDataState] = useState(initialDataState);

  const { data, total } = useMemo(
    () => process(poDocuments || [], variantDataState),
    [variantDataState, poDocuments]
  );

  const onDataStateChange = useCallback(
    (e: GridDataStateChangeEvent) => setVariantDataState(e.dataState),
    []
  );
  const handleClearFilter = useCallback(() => {
    setVariantDataState(initialDataState);
  }, []);

  return (
    <div className="mb-4">
      <Accordion title={`Related Documents for PO ${poNumber || ''}`} defaultExpanded={false}>
        <div className="mt-1 mb-1 px-1">
          <GridWrapper
            id="variancePoDocumentGrid"
            columns={poVarianceColumns}
            dataSource={data}
            dataState={variantDataState}
            className={'max-h-[400px] mb-5'}
            total={total}
            {...defaultProps}
            onDataStateChange={onDataStateChange}
            gridToolbarChildren={
              <VarianceDetailsToolBar
                clearFilter={handleClearFilter}
                showFilter={false}
                state={variantDataState}
              />
            }
            loading={isLoading}
          />
        </div>
      </Accordion>
    </div>
  );
};

export default PoVarianceDocument;
